import _goto, { prev, next } from './base';

/**
 * 跳转商品池
 *
 * @param history
 * @param queryObj
 * @param pushOrReplace
 */
function productPool(history: any, queryObj: any, pushOrReplace = true /* push true replace false */) {
  _goto('/activity-manage/detail/commodity-pool-manage', queryObj, pushOrReplace);
}

function editActivity(history: any, queryObj: any, pushOrReplace = true /* push true replace false */) {
  _goto('/activity-manage/edit', queryObj, pushOrReplace);
}

function goto404() {
  _goto('/404', undefined, false);
}

export default {
  goto404,
  productPool,
  editActivity,
  prev,
  next,
};

export { goto404 };
